import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";

interface DateSelectorProps extends DatePickerProps<Date> {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  label?: string;
}

export const DateSelector = ({ selectedDate, onDateChange, label = "Select Date", ...props }: DateSelectorProps) => {
  return (
    <DatePicker
      label={label}
      value={selectedDate}
      onChange={(date) => {
        date && onDateChange(date);
      }}
      {...props}
    />
  );
};
